<template>
  <div>
    <div class="no-background container is-max-desktop">
      <div class="mx-4">
        <SupporterHero />
      </div>
    </div>
    <BackgroundTop />
    <div class="full-width-background">
      <BackgroundBottom />
    </div>
    <div class="in-front container is-max-desktop">
      <div class="mx-4">
        <MemodioSupporterRows :show-all-supporters="true" />
      </div>
    </div>
  </div>
</template>

<script>
import SupporterHero from "~/components/SupporterHero.vue"
defineI18nRoute({
  paths: {
    en: "/supporters",
    de: "/foerderung",
  },
})
export default {
  name: "MemodioSupporters",
  components: { SupporterHero },
}
</script>

<style lang="scss" scoped>
.full-width-background {
  background-color: $fancy-background;
  width: 100%;
}
</style>
